import { Component } from '@builder.io/sdk';

import { targetAttributeOptions } from '../utils/constants';

export const config: Component = {
    name: 'Button SB',
    inputs: [
        {
            name: 'variant',
            type: 'string',
            defaultValue: 'primary',
            enum: [
                {
                    label: 'primary',
                    value: 'primary',
                },
                {
                    label: 'secondary',
                    value: 'secondary',
                },
                {
                    label: 'outlined-dark',
                    value: 'outlined-dark',
                },
                {
                    label: 'outlined-light',
                    value: 'outlined-light',
                },
                {
                    label: 'text',
                    value: 'text',
                },
                {
                    label: 'alternate',
                    value: 'alternate',
                },
            ],
        },
        {
            name: 'size',
            type: 'string',
            defaultValue: 'default',
            enum: [
                {
                    label: 'default',
                    value: 'default',
                },
                {
                    label: 'large',
                    value: 'large',
                },
            ],
        },
        {
            name: 'type',
            type: 'string',
            defaultValue: 'button',
            enum: [
                {
                    label: 'button',
                    value: 'button',
                },
                {
                    label: 'submit',
                    value: 'submit',
                },
            ],
        },
        {
            name: 'disabled',
            type: 'boolean',
            defaultValue: false,
            enum: [
                {
                    label: 'Enabled',
                    value: false,
                },
                {
                    label: 'Disabled',
                    value: true,
                },
            ],
        },
        {
            name: 'link',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'target',
            type: 'string',
            enum: targetAttributeOptions,
            defaultValue: '_blank',
            helperText: 'https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target',
            showIf: (options) => options.get('link'),
        },
        {
            name: 'className',
            type: 'string',
            defaultValue: '',
        },
    ],
    defaultChildren: [
        {
            '@type': '@builder.io/sdk:Element',
            component: { name: 'Text', options: { text: 'Your content here.' } },
        },
    ],
};
